/* eslint-disable react/no-array-index-key */
import { type ProductListMenuItemViewModel, MenuItemElementViewModelDiscriminator } from 'autogen/swagger/all';
import styled from 'styled-components';
import Menu from 'components/generic/menu';
import { memo } from 'react';
import AccordionMenuItem from './AccordionMenuItem';
import { BrandSpecificMenuItemStyling } from '../shared/styles';

/* #region styles */
const StyledDefaultMenuSection = styled(Menu.SecondarySection)<{ $level: number }>`
    margin-left: ${({ $level }) => `${$level * 12}px`};
    background-color: transparent;
    padding: 0;
    &:after {
        width: 100%;
    }

    &:empty {
        display: none;
    }
`;

const StyledMenuItemAnchor = styled(Menu.Item.Action)<{ selected: boolean }>`
    ${BrandSpecificMenuItemStyling}
`;
/* #endregion */

const ItemsRenderer = ({
    menuItems,
    headline,
    level
}: {
    menuItems: ProductListMenuItemViewModel[];
    headline?: string;
    level: number;
}) => (
    <StyledDefaultMenuSection headline={headline} $level={level}>
        {menuItems.map((item, index) => {
            if (item.children.length) {
                return <AccordionMenuItem key={index} item={item} />;
            }

            return MenuItemElementViewModelDiscriminator(
                item.itemElement,
                ({ text, cssClass }) => (
                    <Menu.Item key={index} selected={item.isSelected} className={cssClass}>
                        {text}
                    </Menu.Item>
                ),
                ({ text, link: action }) => (
                    <StyledMenuItemAnchor key={index} selected={item.isSelected} action={action}>
                        {text}
                    </StyledMenuItemAnchor>
                ),
                () => null
            );
        })}
    </StyledDefaultMenuSection>
);

export default memo(ItemsRenderer);
